import { createAction, props } from '@ngrx/store';

export const selectEntity = createAction(
  '[GLOBAL_SELECT] SELECT_ENTITY',
  props<{ entityName: string; id: number | string }>(),
);
